import React, { useEffect } from 'react';
import './index.css';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Stack,
  useDisclosure,
  Link,
} from '@chakra-ui/react';
import { useState } from 'react';
import * as Yup from 'yup';
import { Form, Formik, ErrorMessage } from 'formik';
import { serverApi } from '../../api/api';
import { CreateLearnerInput } from '../../api/server';
import { IS_DEV, REACT_APP_API_BASE_URL, REACT_APP_SPECIFIED_COMMERCIAL_URL, SERVER_WEBPUSH_PUBLIC_KEY } from '../../configs';
import { responseInterceptor } from 'http-proxy-middleware';
import { getDisplayLangData } from '../../component/json';

const Start = () => {
  const Lang = getDisplayLangData();
  //assets
  const kurashi_study_logo = require('../../assets/images/kurashi_study_logo.png').default;
  // const edit_grey = require('../../assets/images/edit_grey.png').default;
  const cancel_white = require('../../assets/images/cancel_white.png').default;
  const system_words: any = {};
  system_words['ja'] = require('../../assets/jsons/lang/ja.json');
  system_words['en'] = require('../../assets/jsons/lang/en.json');
  system_words['vn'] = require('../../assets/jsons/lang/vn.json');
  system_words['ch'] = require('../../assets/jsons/lang/ch.json');
  //states
  const [email, setEmail] = useState<string>('');
  const [nickName, setNickName] = useState<string>('');
  const [activationCode, setActivationCode] = useState<string>('');
  const [selectedLang, setSelectedLang] = useState<string>('ja');
  useEffect(() => {
    if (localStorage.hasOwnProperty('systemLanguage')){
      setSelectedLang(String(localStorage.getItem('systemLanguage')))
    }
  }, []);
  
  //functions
  const onSubmit = (e: { preventDefault: () => void; }) => {
    // modalによる分岐
    if(activationCode){
      postGroupLearnerMailAddress()
    }else{
      postLearnerMailAddress()
    }
    e.preventDefault();
  };
  const { isOpen, onClose, onOpen } = useDisclosure();
  const onSignup = () => {
    window.location.replace(`/signup`);
  };
  const onSignupGrp = () => {
    window.location.replace(`/signup_grp`);
  };
  const onSignin = () => {
    window.location.replace(`/signin`);
  };

   // Modal切り分け用
   const [selectedItem, setSelectedItem] = useState<string>('');
   const [selectedBtn, setSelectedBtn] = useState<string>('');
   const [message, setMessage] = useState<string>('');
   const onOpenModal = (name: string, target: any) => {
     setSelectedItem(name);
     setSelectedBtn(target!.id);
   };
   const onCloseModal = () => {
     setSelectedItem('');
   };

   const newSW = async () => {
      await navigator.serviceWorker.register(IS_DEV?"http://localhost:3003/sw.js":"/sw.js")
      .then(registration => {
        //SWを登録された
        // console.log('SW registered');
      })
      .catch(err => {
        //SWを登録されるエラー
        // console.log('SW registration failed: ', err);
      });
    }

  async function subscribeSW(org_key: string, learnerId :string) {
    //Push通知に登録する
    await navigator.serviceWorker.ready.then(registration => {
      if ('Notification' in window) {
        registration.pushManager.getSubscription().then(sub => {
          if (sub === null) {
            registration.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: SERVER_WEBPUSH_PUBLIC_KEY
            })
            .then(async res => {
              // APIへsubscribeを登録する activeFlg: 1 = active
              const list:any = (await fetch(
                REACT_APP_API_BASE_URL + '/api/appService/' + org_key + '/LearnerEndpoint/' + learnerId,
                {
                  method: 'PUT',
                  body: JSON.stringify({language_code:localStorage.systemLanguage, active_flg: '1', endpoint: res.endpoint, webpush_object: JSON.stringify(res)}),
                  headers: {'Content-Type': 'application/json'},
                }
              ).then(response => response.json())
              .then(async res => {
                if(res.code == 201){
                  setSelectedItem('resultSuccesstModal');
                }else if(res.code == 400){
                  // setMessage(system_words[selectedLang]['KT_000?_??']);// 'Subscribe NG'
                  setSelectedItem('resultFailModal');
                }else{
                  // setMessage(system_words[selectedLang]['KT_000?_??']);// 'Subscribe NG'
                  setSelectedItem('resultFailModal');
                };
                })
              )
            })
          };
        });
      };
    });
  }

  // メールアドレス登録
  const postLearnerMailAddress = async() => {

    const learnerInput = {
        organization_key: 'kokoka',
        group_id: 0,
        learner_id: '',
        email:email,
        full_name:nickName,
        nick_name:nickName,
        stop_flg: 0,
        prefectures: '',
        municipalities: '',
        activation_code: activationCode,
    }
    // console.log(learnerInput)
    const list:any = (await fetch(
      REACT_APP_API_BASE_URL + '/api/organizations/kokoka/groups/0/learner',
      {
        method: 'POST',
        body: JSON.stringify(learnerInput),
        headers: {'Content-Type': 'application/json'},
      }
    ).then(response => response.json())
    .then(async res => {
      if(res.code == 201){
        //TODO: learner_id取得でkokokaがハードコーディング
        const list:any = (await fetch(
          REACT_APP_API_BASE_URL + '/api/appService/kokoka/learnerEndpoint/' + res.data[0].learner_id,
          {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
          }
        ).then(response => response.json())
          .then(async sw => {
            // SWのPush通知にsubscribe
            navigator.serviceWorker.getRegistration('/').then(async registration => {
              if(registration){
                // SWが存在されている
                registration.pushManager.getSubscription().then(sub => {
                  if (sub !== null) subscribeSW('kokoka',res.data[0].learner_id);
                });
              } else {
                // SWが存在されていない
                // await newSW();
                // subscribeSW('kokoka',res.data[0].learner_id);
              }
            });
          })
        )
        setSelectedItem('resultSuccesstModal');
      }else if(res.code == 400){
        setMessage(system_words[selectedLang]['KT_0008_14']);// 'メールアドレスは既に登録されています。'
        setSelectedItem('resultFailModal');
      }else{
        setMessage(system_words[selectedLang]['KT_0008_15']);// 'メールアドレス登録に失敗しました。メールアドレスを確認して再度登録してください。'
        setSelectedItem('resultFailModal');
      };
    }));
  }

  const postGroupLearnerMailAddress = async() => {
    // アクティベーションコードチェック
    const list:any = (await fetch(
      REACT_APP_API_BASE_URL + `/api/appService/kokoka/activationCode/${activationCode}/${email}`,
      {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
      }
    ).then(response => response.json())
    .then(async res => {
      if(res.code == 200){
        //TODO: learner_id取得でkokokaがハードコーディング
        const list:any = (await fetch(
          REACT_APP_API_BASE_URL + '/api/appService/kokoka/learnerEndpoint/' + `${email}`,
          {
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
          }
        ).then(response => response.json())
          .then(async res => {
            // SWのPush通知にsubscribe
            navigator.serviceWorker.getRegistration('/').then(async registration => {
              if(registration){
                // SWが存在されている
                registration.pushManager.getSubscription().then(sub => {
                  if (sub !== null) subscribeSW('kokoka',res.data.learner_id);
                });
              } else {
                // SWが存在されていない
                await newSW();
                subscribeSW('kokoka',res.data.learner_id);
              }
            });
          })
        )
        setSelectedItem('resultSuccesstModal');
      }else if(res.code == 304){
        setMessage(system_words[selectedLang]['KT_0008_14']);// 'メールアドレスは既に登録されています。'
        setSelectedItem('resultFailModal');
      }else{
        setMessage(system_words[selectedLang]['KT_0008_15']);// 'メールアドレス登録に失敗しました。メールアドレスを確認して再度登録してください。'
        setSelectedItem('resultFailModal');
      };
    }));
    postLearnerMailAddress();
  }
 
  return (
    <>
      <Modal isOpen={'resultSuccesstModal' === selectedItem} onClose={onCloseModal} isCentered>
        <ModalOverlay />
        <ModalContent userSelect="none" maxWidth="345px">
          <ModalHeader bgColor="blue" roundedTop={'md'} textColor="white" textAlign="center">
            {system_words[selectedLang]['KT_0008_11']}
            {/* 登録結果 */}
          </ModalHeader>
          <ModalBody>
            <p>{system_words[selectedLang]['KT_0008_12']}</p>
            {/* メールアドレスを登録しました。 */}
            <p>{system_words[selectedLang]['KT_0008_13']}</p>
            {/* 登録したアドレスへメールが送られますので、内容をご確認ください。 */}
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => window.location.replace('/signIn')}>サインイン画面へ</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={'resultFailModal' === selectedItem} onClose={onCloseModal} isCentered>
        <ModalOverlay />
        <ModalContent userSelect="none" maxWidth="345px">
          <ModalHeader bgColor="blue" roundedTop={'md'} textColor="white" textAlign="center">
            {system_words[selectedLang]['KT_0008_11']}
            {/* 登録結果 */}
          </ModalHeader>
          <ModalBody>
            <p>{message}</p>
          </ModalBody>
          <ModalFooter>
            <Button className="btn-border" onClick={onCloseModal} textColor="white" bgColor="gray" width="30%">
              <Image src={cancel_white} boxSize="20px"></Image>
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Stack id="bg-image" pb="5px" m="auto" w="375px" bgSize="cover" boxSizing="content-box" bgColor="white" justify="center">
        <Flex justifyContent="center" minHeight="64px">
          <Image src={kurashi_study_logo} px="50px" mt="100px" mb="20px" />
        </Flex>
        <Flex textAlign="center" justifyContent="center" px="50px" fontSize="14px">
          {system_words[selectedLang]['KT_0008_01']}
        </Flex>
        <Flex justifyContent="center" margin="5px" pb="20px">
          <Box>
            <Button
              id="single_btn"
              className="btn-border"
              onClick={onSignup}
              textColor="white"
              bgColor="orange"
              w="300px"
            >
              {system_words[selectedLang]['KT_0008_02']}
            </Button>
          </Box>
        </Flex>
        <Flex textAlign="center" justifyContent="center" px="50px" fontSize="14px">
          {system_words[selectedLang]['KT_0008_05']}
        </Flex>
        <Flex justifyContent="center" margin="5px" pb="20px">
          <Box>
            <Button
              id="group_btn"
              className="btn-border"
              onClick={onSignupGrp}
              textColor="white"
              bgColor="orange"
              w="300px"
            >
              {system_words[selectedLang]['KT_0008_06']}
            </Button>
          </Box>
        </Flex>
        <Flex textAlign="center" justifyContent="center" px="50px" fontSize="13px">
          {system_words[selectedLang]['KT_0008_03']}
        </Flex>
        <Flex justifyContent="center" margin="5px" pb="20px">
          <Box>
            <Button
              id="signin_btn"
              className="btn-border"
              onClick={onSignin}
              textColor="white"
              bgColor="orange"
              w="300px"
            >
              {system_words[selectedLang]['KT_0008_04']}
            </Button>
          </Box>
        </Flex>
        <Flex justifyContent="center" pb="20px">
          {/* 特定商取引法 */}
          <Link href={REACT_APP_SPECIFIED_COMMERCIAL_URL} target="_blank" m="10px" color="orange" fontWeight="bold" fontSize="13px" textDecoration="underline">{system_words[selectedLang]['KT_0041_07']}</Link>
        </Flex>
      </Stack>
    </>
  );
};

export default Start;
